import React from "react";

import { css } from "@emotion/css";

const buttonHeight = "3em";
const buttonWidth = "6em";
const buttonGroupGutter = "0.333em";
const buttonGroupBackground = "rgb(140, 140, 227)";
const buttonBorder = `2px solid ${buttonGroupBackground}`;
const buttonBackgroundActive = buttonGroupBackground;
const buttonTextColorActive = "black";
// const buttonTextColorInactive = "blue";

const buttonGroupStyle = css`
  font-size: 1.125rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${buttonHeight};
  border-radius: ${buttonHeight};
  padding: ${buttonGroupGutter};
  border: ${buttonBorder};
  color: white;
  position: relative;
  cursor: pointer;

  input {
    display: none;
  }

  label {
    position: relative;
    width: ${buttonWidth};
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;
  }

  label:last-of-type {
    &:before {
      background: ${buttonBackgroundActive};
      content: "";
      display: block;
      border-radius: calc(${buttonHeight} - ${buttonGroupGutter});
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      transition: transform 0.15s ease;
      will-change: transform;
    }
  }

  input:checked:last-of-type + label:before {
    z-index: -1;
  }

  input:checked + label {
    color: ${buttonTextColorActive};
    z-index: 1;
    position: relative;
  }

  /* two radio buttons */
  input:nth-of-type(1):nth-last-of-type(2),
  input:nth-of-type(2):nth-last-of-type(1) {
    &:nth-of-type(1):checked {
      & ~ label:last-of-type:before {
        transform: translate3d(-100%, 0%, 0);
      }
    }
  }

  /* three items */
  input:nth-of-type(1):nth-last-of-type(3),
  input:nth-of-type(1):nth-last-of-type(3) ~ input {
    &:nth-of-type(1):checked {
      & ~ label:last-of-type:before {
        transform: translate3d(-200%, 0%, 0);
      }
    }

    &:nth-of-type(2):checked {
      & ~ label:last-of-type:before {
        transform: translate3d(-100%, 0%, 0);
      }
    }
  }
`;

const RiskObjectiveButtonGroup = () => {
  const [selected, setSelected] = React.useState("safe");

  return (
    <div className={buttonGroupStyle}>
      <input
        type="radio"
        id="radio-safe"
        name="travel-mode"
        value="safe"
        checked={selected === "safe"}
      />
      <label htmlFor="radio-safe" onClick={() => setSelected("safe")}>
        Safe
      </label>
      <input
        type="radio"
        id="radio-balanced"
        name="travel-mode"
        value="balanced"
        checked={selected === "balanced"}
      />
      <label htmlFor="radio-balanced" onClick={() => setSelected("balanced")}>
        Balanced
      </label>
      <input
        type="radio"
        id="radio-riskon"
        name="travel-mode"
        value="riskon"
        checked={selected === "riskon"}
      />
      <label htmlFor="radio-riskon" onClick={() => setSelected("riskon")}>
        Risk On
      </label>
    </div>
  );
};

export default RiskObjectiveButtonGroup;
